import React, { useState } from 'react';
import './ComponentLibrary.css';

const componentCategories = [
  // {
  //   name: '成员组件',
  //   components: [
  //     { type: 'member_name', label: '姓名', icon: '👤', description: '成员姓名' },
  //     { type: 'member_phone', label: '电话', icon: '📱', description: '成员电话' }
  //   ]
  // },
  {
    name: '活动组件',
    components: [
      { type: 'member_name', label: '姓名', icon: '👤', description: '' },
      { type: 'member_phone', label: '电话', icon: '📱', description: '' },
      { type: 'activity_time', label: '活动时间', icon: '🕒', description: '', props: { placeholder: '请选择活动时间' } },
      { type: 'inspection_community', label: '小区', icon: '🏘️', description: '由用户输入小区名称', props: { placeholder: '请输入小区' } },
      { type: 'activity_brand', label: '品牌', icon: '🏠', description: '品牌单选（下拉选，展示选中的品牌）', props: { options: [], placeholder: '请选择品牌' } },
      { type: 'activity_brand_multi', label: '品牌', icon: '🏷️', description: '品牌多选', props: { options: [], placeholder: '请选择品牌' }, hidden: false },
      { type: 'member_community', label: '小区', icon: '🏘️', description: '小区单选', props: { options: [], placeholder: '请选择小区' } },
      { type: 'member_brand_merchant', label: '品牌', icon: '🏢', description: '品牌单选（下拉选，展示所有商家）', props: { options: [], placeholder: '请选择品牌商家' } },
      { type: 'activity_requirement', label: '考察需求', icon: '📝', description: '考察需求输入', props: { placeholder: '请输入考察需求' } },
      { type: 'shop_address', label: '店铺地址', icon: '📍', description: '店铺地址输入', props: { placeholder: '请输入店铺地址' } },
      { type: 'brand_store_cascader', label: '品牌商家-店铺地址', icon: '🏬', description: '品牌商家-店铺地址级联选择', props: { mapping: [] } },
      // 新增房屋面积组件
      { type: 'house_area', label: '房屋面积', icon: '📐', description: '房屋面积输入', props: { placeholder: '请输入房屋面积' } },
    ]
  },
  {
    name: '验房组件',
    components: [
      { type: 'member_name', label: '姓名', icon: '👤', description: '成员姓名' },
      { type: 'member_phone', label: '电话', icon: '📱', description: '成员电话' },
      { type: 'inspection_community', label: '小区', icon: '🏘️', description: '小区输入', props: { placeholder: '请输入小区' } },
      { type: 'inspection_datetime', label: '验房时间', icon: '🕒', description: '验房时间选择（年月日时分）', props: { placeholder: '请选择验房时间' } },
      // 保留一个 inspection_brand，移除上面那个
      { type: 'inspection_brand', label: '品牌', icon: '🏠', description: '品牌多选', props: { options: [], placeholder: '请选择品牌' } },
      { type: 'house_area', label: '房屋面积', icon: '📐', description: '房屋面积输入', props: { placeholder: '请输入房屋面积' } },
      { type: 'building_number', label: '楼号', icon: '🏢', description: '楼号输入', props: { placeholder: '请输入楼号' } },
      { type: 'vip_card_number', label: '特权黑卡号', icon: '💎', description: '特权黑卡号输入', props: { placeholder: '请输入特权黑卡号' } },
      { type: 'inspection_remark', label: '备注', icon: '📝', description: '备注（多行文本）', props: { placeholder: '请输入备注', multiline: true } }
    ]
  },
  {
    name: '基础组件',
    components: [
      { type: 'input', label: '单行文本框', icon: '📝', description: '用于输入单行文本' },
      { type: 'textarea', label: '多行文本框', icon: '📄', description: '用于输入多行文本' },
      { type: 'number', label: '数字输入框', icon: '🔢', description: '用于输入数字' },
      { type: 'radio', label: '单选框组', icon: '⭕', description: '单选一个选项' },
      { type: 'checkbox', label: '多选框组', icon: '☑️', description: '可多选选项' },
      { type: 'date', label: '日期选择', icon: '📅', description: '选择日期' },
      { type: 'time', label: '时间选择', icon: '⏰', description: '选择时间' },
      { type: 'datetime', label: '日期时间', icon: '📆', description: '选择日期和时间' },
      // { type: 'divider', label: '分割线', icon: '➖', description: '分隔内容' }, // 隐藏分隔线
      { type: 'richtext', label: '富文本', icon: '📝', description: '富文本编辑器' },
    ]
  }
  // 选择组件、媒体组件、高级组件、布局组件全部隐藏
];

export default function ComponentLibrary({ onAddComponent }) {
  const [openIndex, setOpenIndex] = useState(0); // 默认展开活动组件分组

  return (
    <div className="component-library">
      <div className="library-header">
        <h3>组件库</h3>
        <p>点击组件添加到画布</p>
      </div>
      <div className="component-categories">
        {componentCategories.map((category, index) => (
          <div key={index} className="category">
            <h4
              className="category-title"
              style={{
                cursor: 'pointer',
                background: openIndex === index ? '#f0f7ff' : '#f7f7fa',
                borderRadius: 8,
                padding: '10px 12px',
                margin: 0,
                fontWeight: 700,
                color: openIndex === index ? '#1890ff' : '#333'
              }}
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
            >
              {category.name}
              <span style={{ float: 'right', fontWeight: 400 }}>
                {openIndex === index ? '▲' : '▼'}
              </span>
            </h4>
            {openIndex === index && (
            <div className="category-components">
              {category.components.map((comp) => (
                <div
                  key={comp.type}
                  className="component-item"
                  onClick={() => onAddComponent(comp)}
                >
                  <div className="component-icon">{comp.icon}</div>
                  <div className="component-info">
                    <div className="component-label">{comp.label}</div>
                    {comp.description && <div className="component-description">{comp.description}</div>}
                  </div>
                </div>
              ))}
            </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}